import { render, staticRenderFns } from "./PointAwardManage.vue?vue&type=template&id=41b53876&"
import script from "./PointAwardManage.vue?vue&type=script&lang=js&"
export * from "./PointAwardManage.vue?vue&type=script&lang=js&"
import style0 from "./PointAwardManage.vue?vue&type=style&index=0&id=41b53876&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b53876')) {
      api.createRecord('41b53876', component.options)
    } else {
      api.reload('41b53876', component.options)
    }
    module.hot.accept("./PointAwardManage.vue?vue&type=template&id=41b53876&", function () {
      api.rerender('41b53876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/points/point-award-manage/PointAwardManage.vue"
export default component.exports